import React from 'react'
import './Card.css'
function Card({emoji,Heading,details,lnk,linktext}) {
  return (
    <div className="card">
        <img src={emoji} alt=''/>
        <span style={{fontWeight:"bold"}}>{Heading}</span>
        <span style={{fontWeight:"100"}} >{details}</span>
        <button className="button c-button">
         <a href={lnk}>{linktext}</a>
        </button>
    </div>
  )
}

export default Card
